import script from "./ItalyGuide.vue?vue&type=script&lang=ts&setup=true"
export * from "./ItalyGuide.vue?vue&type=script&lang=ts&setup=true"

import "./ItalyGuide.vue?vue&type=style&index=0&id=e3e7c72a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3e7c72a"]])

export default __exports__